import campaign from './models/campaign';
import distributor from './models/distributor';
import document from './models/document';
import order from './models/order';
import plot from './models/plot';
import producer from './models/producer';
import projection from './models/projection';
import quotation from './models/quotation';
import visit from './models/visit';
import deliveryNote from './models/delivery-note';
import conceptPaymentTypes from './models/concept-payment-types';
import receipt from './models/receipt';
import ordersItems from './models/orders-items';

export default {
  namespaced: true,
  modules: {
    campaign,
    distributor,
    document,
    order,
    plot,
    producer,
    projection,
    quotation,
    visit,
    deliveryNote,
    conceptPaymentTypes,
    receipt,
    ordersItems,
  },
};
